<template>
  <v-layout :column="true" class="aside borde width80">
    <template v-for="(item, i) in menuLateral">
      <div
        class="li full"
        v-if="can_access(item)"
        :key="`ml-${i}`"
        v-on:click="select(item)">
          <div class="pa-2 pt-20 menu-icon-wrap">
            <template v-if="item.icon || item.icon_img">
              <v-icon v-if="item.icon" style="color:white;font-size:50px">{{item.icon}}</v-icon>
              <v-img
                v-if="item.icon_img"
                :src="require(`@/assets/icons/${item.icon_img}`)"
                contain
                max-height="50"
                max-width="50"
                class="mx-auto"
              />
            </template>
            <div v-else class="cuadrado_blanco" :class="item.id === selectedMenuId && 'fondo_resaltado_aside'"></div>
            <span
              v-if="item.id === 'my_management' && myManagementPendingTotal > 0"
              class="pending-approval-badge"
            >{{ myManagementPendingBadgeLabel }}</span>
          </div>
          <span :class="[responsiveFont,(item.id === selectedMenuId && 'color_resaltado_aside')]">
            <div v-if="Array.isArray(item.text)" style="display: inline-block;vertical-align: middle;">
              <div v-for="(t,i) in item.text" :key="i">{{t}}</div>
            </div>
            <div v-else style="vertical-align: middle;">
              {{item.text}}
            </div>
          </span>
      </div>
    </template>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      $router: this.$router,
      selected: {},
    };
  },
  computed: {
    responsiveFont () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'font9';
        case 'sm': return 'font10';
        case 'md': return 'font8';
        case 'lg': return 'font9';
        case 'xl': return 'font14';
      }
    },
    activeRouterName(){ return this.$router.currentRoute.name },
    selectedMenuId() {
      this.dev_log(this.activeRouterName,this.menuLateralIndice);
      const item = this.menuLateralIndice[this.activeRouterName];
      if (!item) {
        console.warn(`no se ha definido el menu para ${this.activeRouterName}`);
        return false;
      }
      if (!item.component) console.warn(`no se ha definido componente para ${item.text}. *en archivo router.js`);

      const parent = item.parent;
      if (!parent) return this.activeRouterName;
      
      if (!parent.tabs) console.warn(`no se ha definido tabs para ${item.id}`);
      //si es tab o la misma
      return parent.tabs
        ? parent.tabs.find(f => f.id === this.activeRouterName) && parent.id
        : this.activeRouterName === item.id && item.id;
    },
    menuLateralIndice() { return this.$store.getters.menuLateralIndice },
    menuLateral() { return this.$store.getters.menuLateral },
    myManagementPendingTotal() { return this.$store.getters.myManagementPendingTotal },
    myManagementPendingBadgeLabel() {
      const n = this.myManagementPendingTotal;
      return n > 99 ? '99+' : String(n);
    },
  },
  watch: {
    '$route'() {
      this.fetchMyManagementPendingTotal();
    },
  },
  created() {
    this.fetchMyManagementPendingTotal();
  },
  methods: {
    fetchMyManagementPendingTotal() {
      this.$store.dispatch('refreshMyManagementPendingTotal');
    },
    select(val) { this.go(val) },
    Array,
    go(val) {
      this.$store.dispatch('setProgress',{show:false});
      if (val.href) {
        window.location = val.href;
        return;
      }
      this.$router.push({ name: val.id});
    },
    text(text){ Array.isArray(text) },
    can_access(item) {
      if(item.disabled) return false;
      if (item.only_dev && !this.is_dev) return false;
      if (item.usernames && item.usernames.length) {
        const username = (this.$user && this.$user.username) || '';
        if (!item.usernames.includes(username)) return false;
      }
      if (item.requires_ai_business_partner && !this.$user.is_ai_business_partner) {
        return false;
      }
      if (item.permission_code !== undefined) {
        return this.myPermissionCodes.includes(item.permission_code);
      }
      return item.permission === undefined || this.myPermissions.includes(item.permission)
    }
  },
};
</script>

<style scoped>
.aside {
  text-align: center;
  background-color: rgb(60, 60, 60);
}
.aside span {
  color: white;
  font-weight: bold;
}
.li {
  cursor: pointer;
  padding: 3px;
  vertical-align: top;
  display: inline;
  flex-shrink: 0;
}
.aside img { margin-bottom: 8px }
.li.full:hover { background-color: #696969 }
.aside span.color_resaltado_aside{
  color: rgb(210,157,125); 
  
  /* text-shadow: 2px 0 0 #fff, -2px 0 0 #fff, 0 2px 0 #fff, 0 -2px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff; */
}
.fondo_resaltado_aside{ background-color: rgb(210,157,125)  !important }
.menu-icon-wrap {
  position: relative;
  display: inline-block;
}
.pending-approval-badge {
  position: absolute;
  top: 12px;
  right: 0;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  border-radius: 999px;
  background-color: #dc2626;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
}
</style>
